// src/Pages/views/Invoices/InvoicePage.tsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Col, Container, FormGroup, Row, Badge } from "react-bootstrap";
import Select from "react-select";
import Split from "react-split";
import { groupBy } from "lodash";
import {
  fetchInvoiceTls,
  setDocumentId,
  setTransactionLineRowNumber,
} from "src/redux/reducers/InvoiceManager";
import PDFViewer from "../PdfViewer";
import InvoiceContainer from "./InvoiceContainer";
import useInvoicePDF from "./useInvoicePDF";
import { Formik } from "formik";
import { Invoice2 } from "src/docuclipper/DocuclipperTypes";
import SelectWithErrorBadge from "../DataArchive/TransactionManager/SelectWithErrorBadge";
import { ReduxState } from "src/redux";

const InvoicePage: React.FC = () => {
  const dispatch = useDispatch();
  const {
    documentId,
    transactionLineRowNumber,
    transactionLines,
    documents,
    loading,
    error,
    validationErrors,
  } = useSelector((state: ReduxState) => state.InvoiceManager);

  useEffect(() => {
    dispatch(fetchInvoiceTls());
  }, []);

  // useEffect(() => {
  //   if (transactionLines.length) {
  //     dispatch(setDocumentId(transactionLines[0].documentId));
  //   }
  // }, [transactionLines.length]);

  const tlsByDocId = groupBy(transactionLines, "documentId");

  const rowOptions =
    tlsByDocId?.[documentId || ""]
      ?.sort((a, b) => a.pageNumber - b.pageNumber)
      ?.map((tl, index) => ({
        label: `${index + 1}`,
        value: index,
        hasWarning:
          validationErrors[tl.id || ""] && !validationErrors[tl.id || ""].valid
            ? true
            : false,
      })) || [];

  const transactionLine = documentId
    ? transactionLines.find(
        (tl) =>
          tl.documentId === documentId &&
          tl.rowNumber === transactionLineRowNumber
      )
    : null;

  const { pdfURL, pageNumber } = useInvoicePDF({
    selectedDocumentId: documentId,
    transactionLine,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // if (!transactionLines.length) {
  //   console.log("no tx returning null");
  //   return null;
  // }

  // if (transactionLineRowNumber === null) {
  //   console.log("no transactionLineRowNumber");
  //   return null;
  // }

  // const selectedDocumentId =
  //   documentId || transactionLines?.[0]?.documentId || "";
  // const selectedTransactionLine =
  //   tlsByDocId?.[selectedDocumentId]?.[transactionLineRowNumber];

  // const invoice = selectedTransactionLine?.row
  //   ? (JSON.parse(selectedTransactionLine.row as any) as Invoice2)
  //   : null;

  // if (!invoice) {
  //   console.log("no invoice returning null");
  //   return null;
  // }

  // console.log({ transactionLineRowNumber });
  const rowSelectValue = rowOptions.find(
    (x) => x.value === transactionLineRowNumber
  );

  const documentOptions = documents
    .map((doc) => ({
      label: doc.originalname,
      value: doc.id,
      hasWarning: transactionLines.some(
        (tl) =>
          tl.documentId.toString() === doc.id.toString() &&
          validationErrors[tl.id || ""] &&
          !validationErrors[tl.id || ""].valid
      ),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const documentSelectValue = documentOptions.find(
    (x) => x.value?.toString() === documentId
  );

  const handleDocumentChange = (option) => {
    dispatch(setDocumentId(option.value));
  };

  const handleRowChange = (option) => {
    dispatch(setTransactionLineRowNumber(option.value));
  };

  // const initialValues = {
  //   ...invoice,
  // };

  return (
    <Container fluid>
      {/* <div className="mx-2">
        <Alert variant="info">
          We just added support for converting invoices and receipts. Email{" "}
          <a href="mailto:support@docuclipper.com">support@docuclipper.com</a>{" "}
          if you run into any issues or have feedback.
        </Alert>
      </div> */}
      <Split className="split" sizes={[40, 60]}>
        <div className="d-flex flex-column">
          <Row className="mb-2 mr-1 invoice-tour-select-doc">
            <Col md="8">
              <FormGroup>
                <strong>Document</strong>
                <SelectWithErrorBadge
                  value={documentSelectValue || null}
                  onChange={handleDocumentChange}
                  options={documentOptions}
                />
              </FormGroup>
            </Col>
            <Col md="4">
              {documentId && (
                <FormGroup>
                  <strong>Invoice / Bill</strong>
                  <SelectWithErrorBadge
                    value={rowSelectValue || null}
                    onChange={handleRowChange}
                    options={rowOptions}
                    // isDisabled={!documentId}
                  />
                </FormGroup>
              )}
            </Col>
          </Row>
          <Row className="mr-1">
            <Col md="12">
              {pdfURL && (
                <PDFViewer key={`${documentId}-${pageNumber}`} url={pdfURL} />
              )}
            </Col>
          </Row>
        </div>

        <Row className="ml-1">
          <Col>
            <InvoiceContainer />
          </Col>
        </Row>
      </Split>
    </Container>
  );
};

export default InvoicePage;
